import React from "react";
import { TooltipIcon } from "../TooltipIcon";

export const AdultIconWithTooltip = ({
  title = "Возрастное ограничение 18+",
}) => {
  return (
    <TooltipIcon tooltipText={title}>
      <img src="/adult-icon.svg" alt="Adult" />
    </TooltipIcon>
  );
};
